import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCurrencyNone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 12V13H8V12H16Z",
		fill: "black"
	})
});
export default SvgCurrencyNone;
